
<template>
  <div
    class="w-full min-w-full h-full min-h-full"
  >
    <router-view
      class="w-full min-w-full h-full min-h-full"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';


export default {
  name: 'App',

  components: {

  },

  data() {
    return {

    };
  },

  computed: {
    ...mapState({
      isAuthenticated: state => state.user.isAuthenticated,
    }),
  },

  watch: {
    isAuthenticated(newVal) {
      if (newVal) {
        // Load clubs when user becomes authenticated
        if (this.$store.state.club.availableClubs.length === 0) {
          this.$store.dispatch('getAvailableClubs');
        }
      }
    },
  },

  created() {

  },

  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch('getUserLoginInformation');
      // Only load clubs if not already loaded
      if (this.$store.state.club.availableClubs.length === 0) {
        this.$store.dispatch('getAvailableClubs');
      }
    }
  },

  methods: {

  },
};
</script>

<style>
html {
  font-family: 'Inter', sans-serif;
}
</style>
